import { useModal } from '@ebay/nice-modal-react';
import { useQueryClient } from '@tanstack/react-query';
import { useTranslation } from 'next-i18next';
import { useDialog } from '@zep/dialog';
import { CreditCardIcon, PlusIcon, RotateCircleIcon } from '@zep/icons';
import { Button, Spacing } from '@zep/ui';
import { PlanKeys } from '../../../../../consts';
import { RegisterPaymentCardModal } from '../../../subscription/paymentForm/PaymentCardModal/PaymentCardModal';
import { usePlanPaymentFormContext, usePlanPaymentInfoContext } from '../../PlanPaymentSection/Providers';
export const CardPaymentRegisterSection = () => {
  const {
    t
  } = useTranslation(['subscription']);
  const {
    spaceHashId,
    planPaymentInfo
  } = usePlanPaymentInfoContext();
  const {
    watch,
    setValue,
    formState
  } = usePlanPaymentFormContext();
  const isCardRegistered = watch('isCardRegistered');
  const queryClient = useQueryClient();
  const registerCardModal = useModal(RegisterPaymentCardModal);
  const dialog = useDialog();
  const showEditPaymentCardModal = async () => {
    await registerCardModal.show({
      spaceHashId,
      onSuccess() {
        setValue('isCardRegistered', true);
        queryClient.invalidateQueries(PlanKeys.spaceDetail(spaceHashId));
        registerCardModal.hide();
      },
      onError: async (error: any) => {
        setValue('isCardRegistered', false);
        if (error.status === -157) {
          await dialog.alert({
            title: t('subscription:payment.alertFailCardRegister.title'),
            content: t('subscription:SpaceDetail.changeCardModal.reason', {
              message: error.data.message
            })
          });
          return;
        }

        // FAIL_TO_CREATE_BILLING_KEY
        // FIXME: (주의) 서버의 error 객체의 depth가 error.data.message 일수 있고 error.message 일수 있음;;;
        if (error.status === -155) {
          await dialog.alert({
            title: t('subscription:payment.alertRegisterFail.title', '카드 등록 실패'),
            content: t('subscription:payment.alertRegisterFail.descriptionWithReason', {
              defaultValue: '사유: {{failReason}}',
              failReason: error?.message || '카드 입력 정보를 다시 확인해주세요.'
            })
          });
          return;
        }
        await dialog.alert({
          title: 'UNKNOWN_ERROR',
          content: 'UNKNOWN_ERROR'
        });
      }
    });
  };
  return <>
      {isCardRegistered ? <div className="flex h-[70px] w-full items-center justify-between rounded-[10px] border border-gray-300 bg-white pl-[26px] pr-[24px]">
          <div className="flex items-center gap-[6px]">
            <CreditCardIcon width={18} height={18} />
            <span className="text-body-1-sb font-[600] text-gray-900">
              {planPaymentInfo?.billingInfo?.cardName ?? '우리우리카드'}
            </span>
          </div>
          <Button size="xs" variant="sub" leftSlot={<RotateCircleIcon width={14} height={14} />} onClick={showEditPaymentCardModal}>
            {t('subscription:payment.cardChange.buttonChange', '결제수단 변경')}
          </Button>
        </div> : <>
          <div className="flex h-[70px] w-full items-center justify-between rounded-[10px] border border-gray-300 bg-gray-50 pl-[26px] pr-[24px]">
            <div className="flex items-center gap-[6px]">
              <CreditCardIcon width={18} height={18} />
              <span className="text-body-1-sb font-[600] text-[#27262E8A]">
                {t('subscription:payment.paymentMethod.cardRegister', '결제 카드를 등록해 주세요')}
              </span>
            </div>
            <Button size="xs" leftSlot={<PlusIcon width={14} height={14} />} onClick={showEditPaymentCardModal}>
              {t('subscription:payment.paymentMethod.cardRegisterButton', '카드 등록')}
            </Button>
          </div>
          {formState.errors.isCardRegistered && <div className="flex w-full flex-col justify-start">
              <Spacing size={8} />
              <span className="text-body-2-sb font-[600] text-red">
                {t('subscription:payment.paymentMethod.cardRegister', '결제 카드를 등록해 주세요')}
              </span>
            </div>}
        </>}
    </>;
};